export const isZipFile = (file: File): boolean => {
  return file.type === 'application/zip' || file.name.endsWith('.zip');
};

export const isPptxFile = (name: string): boolean => {
  return name.toLowerCase().endsWith('.pptx');
};

export const getFileExtension = (fileName: string): string => {
  const parts = fileName.split('.');
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
};
